import React from "react";
import styles from "./card.module.scss";

const SingleCard = ({ item }) => {
  const items = item?.description?.[0]?.text?.split("\n");
  return (
    <div className={styles.featureCard}>
      <h3 className={styles.featureTitle}>{item?.title}</h3>

      <div className={styles.itemsContainer}>
        {items?.map((item, itemIndex) => (
          <div key={itemIndex} className={styles.itemWrapper}>
            <p className={styles.itemText}>{item}</p>
            <div className={styles.itemUnderline}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SingleCard;
